module.exports = require("./fr-SY.d.ts");